// ##############################
// // // HeaderLinks styles
// #############################

import {
    container,
    defaultFont,
    dangerColor,
    primaryColor,
    primaryBoxShadow,
    successColor,
    warningColor,
    infoColor,
    defaultBoxShadow,
    containerFluid,
    transition,
    boxShadow,
    drawerWidth,
} from 'Constants';

export const headerLinksStyle = theme => ({
    popperClose: {
        pointerEvents: 'none',
    },
    search: {
        [theme.breakpoints.down('sm')]: {
            margin: '10px 15px',
            float: 'none !important',
            paddingTop: '1px',
            paddingBottom: '1px',
            padding: '10px 15px',
            width: 'auto',
        },
    },
    searchInput: {
        paddingTop: '2px',
    },
    searchRTL: {
        [theme.breakpoints.down('sm')]: {
            marginRight: '18px !important',
        },
        [theme.breakpoints.up('md')]: {
            marginLeft: '12px',
        },
    },
    linkText: {
        zIndex: '4',
        ...defaultFont,
        fontSize: '14px',
        margin: '0!important',
    },
    itemLink: {
        backgroundColor: 'transparent',
        ...defaultFont,
        width: 'auto',
        '&:hover': {
            outline: 'none',
            backgroundColor: 'rgba(200, 200, 200, 0.2)',
            boxShadow: 'none',
        },
        '&,&:hover,&:focus': {
            color: 'inherit',
        },
    },
    buttonLink: {
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            marginLeft: '30px',
            width: 'auto',
        },
    },
    searchButton: {
        [theme.breakpoints.down('sm')]: {
            top: '-50px !important',
            marginRight: '38px',
            float: 'right',
        },
    },
    top: {
        zIndex: '4',
    },
    searchIcon: {
        width: '17px',
        zIndex: '4',
    },
    links: {
        width: '20px',
        height: '20px',
        zIndex: '4',
        [theme.breakpoints.down('sm')]: {
            display: 'block',
            width: '30px',
            height: '30px',
            color: 'inherit',
            opacity: '0.8',
            marginRight: '16px',
            marginLeft: '-5px',
        },
    },
    notifications: {
        zIndex: '4',
        [theme.breakpoints.up('md')]: {
            position: 'absolute',
            top: '5px',
            border: '1px solid #FFF',
            right: '10px',
            fontSize: '9px',
            background: dangerColor,
            color: '#FFFFFF',
            minWidth: '16px',
            height: '16px',
            borderRadius: '10px',
            textAlign: 'center',
            lineHeight: '14px',
            verticalAlign: 'middle',
            display: 'block',
        },
        [theme.breakpoints.down('sm')]: {
            ...defaultFont,
            fontSize: '14px',
            marginRight: '8px',
        },
    },
    dropdown: {
        borderRadius: '3px',
        border: '0',
        boxShadow: '0 2px 5px 0 rgba(0, 0, 0, 0.26)',
        top: '100%',
        zIndex: '1000',
        minWidth: '160px',
        padding: '5px 0',
        margin: '2px 0 0',
        fontSize: '14px',
        textAlign: 'left',
        listStyle: 'none',
        backgroundColor: '#fff',
        backgroundClip: 'padding-box',
    },
    pooperResponsive: {
        [theme.breakpoints.down('sm')]: {
            zIndex: '1640',
            position: 'static',
            float: 'none',
            width: 'auto',
            marginTop: '0',
            backgroundColor: 'transparent',
            border: '0',
            boxShadow: 'none',
            color: 'black',
        },
    },
    dropdownItem: {
        ...defaultFont,
        fontSize: '13px',
        padding: '10px 20px',
        margin: '0 5px',
        borderRadius: '2px',
        position: 'relative',
        transition: 'all 150ms linear',
        display: 'block',
        clear: 'both',
        fontWeight: '400',
        height: 'fit-content',
        color: '#333',
        whiteSpace: 'nowrap',
        '&:hover': {
            backgroundColor: primaryColor,
            color: '#FFFFFF',
            ...primaryBoxShadow
        },
    },
    dropdownItemRTL: {
        textAlign: 'right !important',
    },
    wrapperRTL: {
        [theme.breakpoints.up('md')]: {
            paddingLeft: '16px',
        },
    },
    buttonLinkRTL: {
        [theme.breakpoints.down('sm')]: {
            alignItems: 'center',
            justifyContent: 'flex-end',
            width: '-webkit-fill-available',
            margin: '10px 15px 0',
            padding: '10px 15px',
            display: 'block',
            position: 'relative',
        },
    },
    labelRTL: {
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'row-reverse',
            justifyContent: 'initial',
        },
    },
    linksRTL: {
        [theme.breakpoints.down('sm')]: {
            marginRight: '-5px',
            marginLeft: '16px',
        },
    },
    managerClasses: {
        [theme.breakpoints.up('md')]: {
            display: 'inline-block',
        },
    },
});

export const headerStyle = () => ({
    appBar: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
        borderBottom: '0',
        marginBottom: '0',
        position: 'absolute',
        width: '100%',
        paddingTop: '10px',
        zIndex: '1029',
        color: '#555555',
        border: '0',
        borderRadius: '3px',
        padding: '10px 0',
        transition: 'all 150ms ease 0s',
        minHeight: '50px',
        display: 'block',
    },
    container: {
        ...containerFluid,
        minHeight: '50px',
    },
    flex: {
        flex: 1,
    },
    title: {
        ...defaultFont,
        lineHeight: '30px',
        fontSize: '36px',
        borderRadius: '3px',
        textTransform: 'uppercase',
        fontWeight:'bold',
        color: '#333333',
        '&:hover,&:focus': {
            background: 'transparent',
        },
    },
    primary: {
        backgroundColor: primaryColor,
        color: '#FFFFFF',
        ...defaultBoxShadow
    },
    info: {
        backgroundColor: infoColor,
        color: '#FFFFFF',
        ...defaultBoxShadow
    },
    success: {
        backgroundColor: successColor,
        color: '#FFFFFF',
        ...defaultBoxShadow
    },
    warning: {
        backgroundColor: warningColor,
        color: '#FFFFFF',
        ...defaultBoxShadow
    },
    danger: {
        backgroundColor: dangerColor,
        color: '#FFFFFF',
        ...defaultBoxShadow
    },
    sidebarMinimize: {
        float: 'left',
        padding: '0 0 0 15px',
        display: 'block',
        color: '#555555',
    },
    sidebarMinimizeRTL: {
        padding: '0 15px 0 0 !important',
    },
    sidebarMiniIcon: {
        width: '20px',
        height: '17px',
    },
});

export const pagesHeaderStyle = theme => ({
    appBar: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
        borderBottom: '0',
        marginBottom: '0',
        position: 'absolute',
        width: '100%',
        paddingTop: '10px',
        zIndex: '1029',
        color: '#555555',
        border: '0',
        borderRadius: '3px',
        padding: '10px 0',
        transition: 'all 150ms ease 0s',
        minHeight: '50px',
        display: 'block',
    },
    container: {
        ...container,
        minHeight: '50px',
    },
    flex: {
        flex: 1,
    },
    title: {
        ...defaultFont,
        lineHeight: '30px',
        fontSize: '18px',
        borderRadius: '3px',
        textTransform: 'none',
        color: '#FFFFFF',
        '&:hover,&:focus': {
            background: 'transparent',
            color: '#FFFFFF',
        },
    },
    appResponsive: {
        top: '8px',
    },
    primary: {
        backgroundColor: primaryColor,
        color: '#FFFFFF',
        ...defaultBoxShadow
    },
    info: {
        backgroundColor: infoColor,
        color: '#FFFFFF',
        ...defaultBoxShadow
    },
    success: {
        backgroundColor: successColor,
        color: '#FFFFFF',
        ...defaultBoxShadow
    },
    warning: {
        backgroundColor: warningColor,
        color: '#FFFFFF',
        ...defaultBoxShadow
    },
    danger: {
        backgroundColor: dangerColor,
        color: '#FFFFFF',
        ...defaultBoxShadow
    },
    list: {
        ...defaultFont,
        fontSize: '14px',
        margin: 0,
        marginRight: '-15px',
        paddingLeft: '0',
        listStyle: 'none',
        color: '#FFFFFF',
        paddingTop: '0',
        paddingBottom: '0',
    },
    listItem: {
        float: 'left',
        position: 'relative',
        display: 'block',
        width: 'auto',
        margin: '0',
        padding: '0',
        [theme.breakpoints.down('sm')]: {
            zIndex: '999',
            width: '100%',
            paddingRight: '15px',
        },
    },
    navLink: {
        color: '#FFFFFF',
        margin: '0 5px',
        paddingTop: '15px',
        paddingBottom: '15px',
        fontWeight: '500',
        fontSize: '12px',
        textTransform: 'uppercase',
        borderRadius: '3px',
        lineHeight: '20px',
        position: 'relative',
        display: 'block',
        padding: '10px 15px',
        textDecoration: 'none',
        '&:hover,&:focus': {
            color: '#FFFFFF',
            background: 'rgba(200, 200, 200, 0.2)',
        },
    },
    listItemIcon: {
        marginTop: '-3px',
        top: '0px',
        position: 'relative',
        marginRight: '3px',
        width: '20px',
        height: '20px',
        verticalAlign: 'middle',
        color: 'inherit',
        display: 'inline-block',
    },
    listItemText: {
        flex: 'none',
        padding: '0',
        minWidth: '0',
        margin: 0,
        display: 'inline-block',
        position: 'relative',
        whiteSpace: 'nowrap',
    },
    navLinkActive: {
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
    drawerPaper: {
        border: 'none',
        bottom: '0',
        transitionProperty: 'top, bottom, width',
        transitionDuration: '.2s, .2s, .35s',
        transitionTimingFunction: 'linear, linear, ease',
        ...boxShadow,
        width: drawerWidth,
        ...boxShadow,
        position: 'fixed',
        display: 'block',
        top: '0',
        height: '100vh',
        right: '0',
        left: 'auto',
        visibility: 'visible',
        overflowY: 'visible',
        borderTop: 'none',
        textAlign: 'left',
        paddingRight: '0px',
        paddingLeft: '0',
        ...transition,
        '&:before,&:after': {
            position: 'absolute',
            zIndex: '3',
            width: '100%',
            height: '100%',
            content: '""',
            display: 'block',
            top: '0',
        },
        '&:after': {
            background: '#000',
            opacity: '.8',
        },
    },
    sidebarButton: {
        color: '#FFFFFF',
        top: '8px',
    },
});



// WEBPACK FOOTER //
// ./src/common/Header/styles.jsx